import { Injectable } from '@angular/core';
import { SearchPlacementResult } from '../../_models/placement-search/search-placement-result.model';

@Injectable({
  providedIn: 'root'
})
export class PlacementSearchDataHelperService {

  public clientNameOrId: string;
  public bookingId: string;
  public searchTerm: string;
  public showEnded: boolean = false;
  public clientIds: Array<number> = new Array<number>();
  /** Selected brands; empty means every brand the user may see. */
  public companyIds: Array<number> = new Array<number>();
  /** filters.booking-search filters; null means no filter. Sent only while the switch is on. */
  public deliveryMode: string = null;
  public provisionType: string = null;
  public startFrom: string = null;
  public startTo: string = null;

  public placements: Array<SearchPlacementResult> = new Array<SearchPlacementResult>();

  constructor() { }
}
